import { useMediaQuery, useTheme } from '@material-ui/core'
import { Cancel } from '@material-ui/icons'
import React from 'react'
import {
  Create,
  ListButton,
  SaveButton,
  SimpleForm,
  Toolbar,
  ToolbarProps,
  useTranslate,
  CreateProps,
  TextInput,
  NumberInput,
  SelectInput,
} from 'react-admin'
import { useLocation } from 'react-router-dom'
import { TicketType } from '../../core/enum/TicketType'
import { TicketDto } from '../../core/dto/ticket.dto'

const validateServiceBookingCreate = (values: TicketDto) => {
  const errors: { [n: string]: string } = {}
  if (!values.bookingId) {
    errors.bookingId = 'ra.validation.required'
  }
  if (!values.ticketCode) {
    errors.ticketCode = 'ra.validation.required'
  }
  if (!values.ticketType) {
    errors.ticketType = 'ra.validation.required'
  }
  return errors
}

const CreateTitle = () => {
  const translate = useTranslate()
  return <span>{translate('resources.tickets.titles.create')}</span>
}

const CreateToolbar = (props: ToolbarProps) => {
  const { basePath, ...rest } = props

  return (
    <Toolbar {...rest}>
      <SaveButton />
      <ListButton basePath={basePath} icon={<Cancel />} label="const.cancel" />
    </Toolbar>
  )
}

export const TicketCreate = (props: CreateProps) => {
  const translate = useTranslate()
  const theme = useTheme()
  const smallScreen = useMediaQuery(theme.breakpoints.down('sm'))
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const bookingId = queryParams.get('bookingId')

  return (
    <Create
      {...props}
      hasShow={false}
      title={<CreateTitle />}
      basePath={`/bookings/${bookingId}/show/tickets`}
    >
      <SimpleForm
        toolbar={<CreateToolbar />}
        validate={validateServiceBookingCreate}
        redirect={`/bookings/${bookingId}/show/tickets`}
        initialValues={{
          bookingId,
        }}
      >
        <NumberInput source="bookingId" disabled />
        <TextInput source="ticketCode" />

        <SelectInput
          variant={!smallScreen ? 'standard' : undefined}
          source="ticketType"
          choices={Object.keys(TicketType).map((key: string) => ({
            id: key,
            name: translate(`resources.enums.ticketType.${key}`),
          }))}
        />
      </SimpleForm>
    </Create>
  )
}
